var _mask, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavBarLarge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1500,
    height: 143,
    viewBox: "0 0 1500 143",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_786_139",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1500 0H0V90H527.079C534.674 120.445 562.203 143 595 143H753.896H905C937.797 143 965.326 120.445 972.921 90H1500V0Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1500 0H0V90H527.079C534.674 120.445 562.203 143 595 143H753.896H905C937.797 143 965.326 120.445 972.921 90H1500V0Z",
    fill: "#F5E9D7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V-2H-2V0H0ZM1500 0H1502V-2H1500V0ZM0 90H-2V92H0V90ZM527.079 90L529.019 89.5159L528.641 88H527.079V90ZM972.921 90V88H971.359L970.981 89.5159L972.921 90ZM1500 90V92H1502V90H1500ZM0 2H1500V-2H0V2ZM2 90V0H-2V90H2ZM527.079 88H0V92H527.079V88ZM595 141C563.143 141 536.398 119.091 529.019 89.5159L525.138 90.4841C532.951 121.799 561.263 145 595 145V141ZM753.896 141H595V145H753.896V141ZM905 141H753.896V145H905V141ZM970.981 89.5159C963.602 119.091 936.857 141 905 141V145C938.737 145 967.049 121.799 974.862 90.4841L970.981 89.5159ZM1500 88H972.921V92H1500V88ZM1498 0V90H1502V0H1498Z",
    fill: "#41220E",
    mask: "url(#path-1-inside-1_786_139)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavBarLarge);
export default __webpack_public_path__ + "static/media/NavBarLarge.384e565359d1945caa1814e3b972f7ca.svg";
export { ForwardRef as ReactComponent };